export const ManufacturerTableconstant = {
  MANUFACTURER_TABLE_SAGA: "MANUFACTURER_TABLE_SAGA",
  MANUFACTURER_TABLE_REQUEST: "MANUFACTURER_TABLE_REQUEST",
  MANUFACTURER_TABLE_RESPONSE: "MANUFACTURER_TABLE_RESPONSE",
  MANUFACTURER_TABLE_API: "/manufacturer-list",

  // post add manufacture
  POST_ADD_MANUFACTURER_SAGA: "POST_ADD_MANUFACTURER_SAGA",
  POST_ADD_MANUFACTURER_REQUEST: "POST_ADD_MANUFACTURER_REQUEST",
  POST_ADD_MANUFACTURER_RESPONSE: "POST_ADD_MANUFACTURER_RESPONSE",
  POST_ADD_MANUFACTURER_API: "/manufacturer",

  GET_ADD_MANUFACTURER_SAGA: "GET_ADD_MANUFACTURER_SAGA",
  GET_ADD_MANUFACTURER_REQUEST: "GET_ADD_MANUFACTURER_REQUEST",
  GET_ADD_MANUFACTURER_RESPONSE: "GET_ADD_MANUFACTURER_RESPONSE",
  GET_ADD_MANUFACTURER_API: "/manufacturers",

  POST_ADD_VEHICLE_MODEL_SAGA: "POST_ADD_VEHICLE_MODEL_SAGA",
  POST_ADD_VEHICLE_MODEL_REQUEST: "POST_ADD_VEHICLE_MODEL_REQUEST",
  POST_ADD_VEHICLE_MODEL_RESPONSE: "POST_ADD_VEHICLE_MODEL_RESPONSE",
  POST_ADD_VEHICLE_MODEL_API: "/vehicle-model",

  POST_ADD_CONNECTORS_MODEL_SAGA: "POST_ADD_CONNECTORS_MODEL_SAGA",
  POST_ADD_CONNECTORS_MODEL_REQUEST: "POST_ADD_CONNECTORS_MODEL_REQUEST",
  POST_ADD_CONNECTORS_MODEL_RESPONSE: "POST_ADD_CONNECTORS_MODEL_RESPONSE",
  POST_ADD_CONNECTORS_MODEL_API: "vehicleconnector",

  GET_ADD_VEHICLE_MODEL_SAGA: "GET_ADD_VEHICLE_MODEL_SAGA",
  GET_ADD_VEHICLE_MODEL_REQUEST: "GET_ADD_VEHICLE_MODEL_REQUEST",
  GET_ADD_VEHICLE_MODEL_RESPONSE: "GET_ADD_VEHICLE_MODEL_RESPONSE",
  GET_ADD_VEHICLE_MODEL_API: "/vehicle-models",

  GET_ADD_CONNECTORS_MODEL_SAGA: "GET_ADD_CONNECTORS_MODEL_SAGA",
  GET_ADD_CONNECTORS_MODEL_REQUEST: "GET_ADD_CONNECTORS_MODEL_REQUEST",
  GET_ADD_CONNECTORS_MODEL_RESPONSE: "GET_ADD_CONNECTORS_MODEL_RESPONSE",
  GET_ADD_CONNECTORS_MODEL_API: "/charger-types",

  //enable*disable
  VEHICLEMANUFACTURE_ENABLE_DISABLE_SAGA: "VEHICLEMANUFACTURE_ENABLE_DISABLE_SAGA",
  VEHICLEMANUFACTURE_ENABLE_DISABLE_REQUEST: "VEHICLEMANUFACTURE_ENABLE_DISABLE_REQUEST",
  VEHICLEMANUFACTURE_ENABLE_DISABLE_RESPONSE:"VEHICLEMANUFACTURE_ENABLE_DISABLE_RESPONSE",
   VEHICLEMANUFACTURE_ENABLE_DISABLE_API: "/vehicle-model ",

   //MANUFACTURER ENABLE DEASBLE 111

  MANUFACTURER_ENABLE_DISABLE_SAGA: "MANUFACTURER_ENABLE_DISABLE_SAGA",
  MANUFACTURER_ENABLE_DISABLE_REQUEST: "MANUFACTURER_ENABLE_DISABLE_REQUEST",
  MANUFACTURER_ENABLE_DISABLE_RESPONSE: "MANUFACTURER_ENABLE_DISABLE_RESPONSE",
  MANUFACTURER_ENABLE_DISABLE_API: "/enable-disable-manufacturer ",



  //enable*disable
  POST_ADD_CONNECTORS_MODEL_SAGA: "POST_ADD_CONNECTORS_MODEL_SAGA",
  POST_ADD_CONNECTORS_MODEL_REQUEST: "POST_ADD_CONNECTORS_MODEL_REQUEST",
  POST_ADD_CONNECTORS_MODEL_RESPONSE: "POST_ADD_CONNECTORS_MODEL_RESPONSE",
  POST_ADD_CONNECTORS_MODEL_API: "/charger-type",

  CONNECTORS_ENABLE_DISABLE_SAGA: "CONNECTORS_ENABLE_DISABLE_SAGA",
  CONNECTORS_ENABLE_DISABLE_REQUEST: "CONNECTORS_ENABLE_DISABLE_REQUEST",
  CONNECTORS_ENABLE_DISABLE_RESPONSE: "CONNECTORS_ENABLE_DISABLE_RESPONSE",
  CONNECTORS_ENABLE_DISABLE_API: "/charger-type",

  //AddVehiclemanufacture
  ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_SAGA: "ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_SAGA",
  ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_REQUEST: "ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_REQUEST",
  ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_RESPONSE:"ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_RESPONSE",
  ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_API: "/manufacturer",

  //update vechilemanufacture

  UPDATE_ADD_MANUFACTURER_SAGA: "UPDATE_ADD_MANUFACTURER_SAGA",
  UPDATE_ADD_MANUFACTURER_REQUEST: "UPDATE_ADD_MANUFACTURER_REQUEST",
  UPDATE_ADD_MANUFACTURER_RESPONSE: "UPDATE_ADD_MANUFACTURER_RESPONSE",
  UPDATE_ADD_MANUFACTURER_API: "/manufacturer",



//update vehicle


  UPDATE_ADD_VEHICLE_MODEL_SAGA: "UPDATE_ADD_VEHICLE_MODEL_SAGA",
  UPDATE_ADD_VEHICLE_MODEL_REQUEST: "UPDATE_ADD_VEHICLE_MODEL_REQUEST",
  UPDATE_ADD_VEHICLE_MODEL_RESPONSE: "UPDATE_ADD_VEHICLE_MODEL_RESPONSE",
  UPDATE_ADD_VEHICLE_MODEL_API: "/vehicle-model",

  //update connector
  UPDATE_ADD_CONNECTOR_SAGA: "UPDATE_ADD_CONNECTOR_SAGA",
  UPDATE_ADD_CONNECTOR_REQUEST: "UPDATE_ADD_CONNECTOR_REQUEST",
  UPDATE_ADD_CONNECTOR_RESPONSE: "UPDATE_ADD_CONNECTOR_RESPONSE",
  UPDATE_ADD_CONNECTOR_API: "/charger-type",


  // get select vehicle 

  GET_SELECT_VEHICLE_SAGA: "GET_SELECT_VEHICLE_SAGA",
  GET_SELECT_VEHICLE_REQUEST: "GET_SELECT_VEHICLE_REQUEST",
  GET_SELECT_VEHICLE_RESPONSE: "GET_SELECT_VEHICLE_RESPONSE",
  GET_SELECT_VEHICLE_API: "/manufacturers",

 

// get select vehicle model for map detail

  GET_SELECT_VEHICLE_MODEL_SAGA: "GET_SELECT_VEHICLE_MODEL_SAGA",
  GET_SELECT_VEHICLE_MODEL_REQUEST: "GET_SELECT_VEHICLE_MODEL_REQUEST",
  GET_SELECT_VEHICLE_MODEL_RESPONSE: "GET_SELECT_VEHICLE_MODEL_RESPONSE",
  GET_SELECT_VEHICLE_MODEL_API: "/vehicle-models",




  // map post
  UPDATE_MAP_SAGA: "UPDATE_MAP_SAGA",
  UPDATE_MAP_REQUEST: "UPDATE_MAP_REQUEST",
  UPDATE_MAP_RESPONSE: "UPDATE_MAP_RESPONSE",
  UPDATE_MAP_API: "/vehicle-connector",

  //add vehicle variant
  POST_ADD_VEHICLE_VARIANT_SAGA: "POST_ADD_VEHICLE_VARIANT_SAGA",
  POST_ADD_VEHICLE_VARIANT_REQUEST: "POST_ADD_VEHICLE_VARIANT_REQUEST",
  POST_ADD_VEHICLE_VARIANT_RESPONSE: "POST_ADD_VEHICLE_VARIANT_RESPONSE",
  POST_ADD_VEHICLE_VARIANT_API: "/vehicle-variant",

  //get vehicle Variant
  GET_ADD_VEHICLE_VARIANT_SAGA: "GET_ADD_VEHICLE_VARIANT_SAGA",
  GET_ADD_VEHICLE_VARIANT_REQUEST: "GET_ADD_VEHICLE_VARIANT_REQUEST",
  GET_ADD_VEHICLE_VARIANT_RESPONSE: "GET_ADD_VEHICLE_VARIANT_RESPONSE",
  GET_ADD_VEHICLE_VARIANT_API: "/vehicle-variants",

  //Edit vehicle variant

  UPDATE_ADD_VEHICLE_VARIANT_SAGA: "UPDATE_ADD_VEHICLE_VARIANT_SAGA",
  UPDATE_ADD_VEHICLE_VARIANT_REQUEST: "UPDATE_ADD_VEHICLE_VARIANT_REQUEST",
  UPDATE_ADD_VEHICLE_VARIANT_RESPONSE: "UPDATE_ADD_VEHICLE_VARIANT_RESPONSE",
  UPDATE_ADD_VEHICLE_VARIANT_API: "/vehicle-variant",

  
  VEHICLE_MODEL_TYPE_SAGA: "VEHICLE_MODEL_TYPE_SAGA",
  VEHICLE_MODEL_TYPE_REQUEST: "VEHICLE_MODEL_TYPE_REQUEST",
  VEHICLE_MODEL_TYPE_RESPONSE: "VEHICLE_MODEL_TYPE_RESPONSE",
  VEHICLE_MODEL_TYPE_API: "/vehicle-types-dropdowns",

};
